/**
 * Format a whole-dollar plan price for display (no decimals).
 * Uses the UI locale so Spanish gets `4.990`, English `4,990`, etc.
 *
 * `useGrouping: true` is required: Node / Chrome leave grouping OFF for
 * `es-ES` by default, so 4990 would render as "4990" instead of "4.990".
 */
export function formatPlanPrice(amount: number, locale: string): string {
  const n = Number.isFinite(amount) ? Math.round(amount) : 0;
  const intl =
    locale === 'en' ? 'en-US'
    : locale === 'de' ? 'de-DE'
    : locale === 'fr' ? 'fr-FR'
    : locale === 'pt' ? 'pt-BR'
    : 'es-ES';
  const formatted = n.toLocaleString(intl, {
    maximumFractionDigits: 0,
    useGrouping: true,
  });
  return locale === 'fr' ? formatted.replace(/[\u202f\u00a0 ]/g, '.') : formatted;
}

/** `$` + locale-formatted amount, e.g. `$4.990` / `$4,990`. */
export function formatPlanPriceUsd(amount: number, locale: string): string {
  return `$${formatPlanPrice(amount, locale)}`;
}
